import { render, staticRenderFns } from "./AydinlatmaMetni.vue?vue&type=template&id=4b94fa08&scoped=true&"
import script from "./AydinlatmaMetni.vue?vue&type=script&lang=js&"
export * from "./AydinlatmaMetni.vue?vue&type=script&lang=js&"
import style0 from "./AydinlatmaMetni.vue?vue&type=style&index=0&id=4b94fa08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94fa08",
  null
  
)

export default component.exports